<template>
  <div class="autocomplete-wrapper">
    <autocomplete
      :source="searchUrl"
      :results-display="formattedDisplay"
      input-class="autocomplete"
      @selected="onSelect">>
    </autocomplete>
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'

export default {
  name: 'searchfield',
  data () {
    return {
      searchUrl: process.env.VUE_APP_KHAZAD_URI + '/games/search/query?q='
    }
  },
  components: {
    Autocomplete
  },
  methods: {
    onSelect (elem) {
      this.$router.push(
        { name: 'game-details',
          params: {
            slug: elem.selectedObject.slug
          }
        })
    },
    formattedDisplay (result) {
      return result.name
    }
  }
}
</script>

<style>
.autocomplete-wrapper {
  margin-top: 20px;
}

.autocomplete {
  height: 35px;
}

@media (max-width: 768px) {
  .autocomplete-wrapper {
    margin-top: 0px;
  }
}
</style>
